module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/logo_1-759aa6fb1dfa048be32f10d5260231df.svg";